import { NavLink } from 'react-router-dom'

interface NavItem {
  label: string
  href?: string
}

const NAV_ITEMS: NavItem[] = [
  { label: 'Dashboard', href: '/dashboard' },
  { label: 'Portfolio', href: '/positions' },
  { label: 'Imports', href: '/imports' },
  { label: 'Trades' },
  { label: 'Strategy', href: '/strategy' },
  { label: 'Alerts', href: '/alerts' },
  { label: 'Profit-Taking', href: '/profit-taking' },
  { label: 'Rebalance', href: '/rebalance' },
  { label: 'Asset-Check', href: '/asset-check' },
  { label: 'What-if', href: '/what-if' },
  { label: 'Onboarding', href: '/onboarding' },
  { label: 'Settings', href: '/settings' },
]

export function Sidebar() {
  return (
    <aside
      aria-label="Sekundärnavigation"
      className="hairline-r hidden w-48 shrink-0 bg-panel px-4 py-6 md:flex md:flex-col"
    >
      <p className="tracked-caps mb-4 px-2 text-[10px] text-faint">Navigation</p>
      <nav className="flex flex-col">
        {NAV_ITEMS.map((item) =>
          item.href ? (
            <NavLink
              key={item.label}
              to={item.href}
              className={({ isActive }) =>
                [
                  'flex items-baseline gap-3 px-2 py-2 text-sm transition-colors',
                  isActive ? 'text-ink' : 'text-muted hover:text-ink',
                ].join(' ')
              }
            >
              {({ isActive }) => (
                <>
                  <span aria-hidden="true" className="w-3 font-mono text-bernstein">
                    {isActive ? '▸' : ''}
                  </span>
                  <span>{item.label}</span>
                </>
              )}
            </NavLink>
          ) : (
            <div
              key={item.label}
              aria-disabled="true"
              title="Kommt später"
              className="flex cursor-not-allowed items-baseline gap-3 px-2 py-2 text-sm text-faint"
            >
              <span aria-hidden="true" className="w-3" />
              <span>{item.label}</span>
            </div>
          ),
        )}
      </nav>
    </aside>
  )
}
